import { render, staticRenderFns } from "./RegionalCreate.vue?vue&type=template&id=de3ba008&"
import script from "./RegionalCreate.vue?vue&type=script&lang=js&"
export * from "./RegionalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports